import { createContext, useContext, useEffect, useState } from "react";
import { RechercheGlobale } from "@/components/RechercheGlobale";
import { NouvelleFicheDialog } from "@/components/fiche/NouvelleFicheDialog";
import { ImportDialog } from "@/components/ImportDialog";

const Ctx = createContext(null);

export function ActionsProvider({ children }) {
  const [ouvert, setOuvert] = useState("");
  useEffect(() => {
    const clavier = (e) => { if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setOuvert("recherche"); } };
    window.addEventListener("keydown", clavier);
    return () => window.removeEventListener("keydown", clavier);
  }, []);
  const etat = (nom) => ({ ouvert: ouvert === nom, setOuvert: (o) => setOuvert(o ? nom : "") });
  return (
    <Ctx.Provider value={{ ouvrir: setOuvert }}>
      {children}
      <RechercheGlobale {...etat("recherche")} />
      <NouvelleFicheDialog {...etat("nouvelle_fiche")} />
      <ImportDialog {...etat("importer")} />
    </Ctx.Provider>
  );
}

export const useActions = () => useContext(Ctx);
